import type { UserRole } from './types';
import type { RootState } from 'src/state';

export function selectUser(state: RootState) {
  return state.user;
}

export function selectUserLanguage(state: RootState) {
  return state.user.language;
}

export function getRole(state: RootState): UserRole {
  return state.user.role;
}
